<script lang="ts">
    import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
    import { faNewspaper } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
    import type { Signal } from '@preact/signals-react';

    interface Props {
        ticker: Signal<string | undefined>;
        changeDirection: Signal<number>;
    }

    let { ticker, changeDirection }: Props = $props();
</script>

<span class="news-icon-hover" data-ticker={$ticker} data-change-direction={$changeDirection}>
    <FontAwesomeIcon icon={faNewspaper} class="text-steel-500" />
</span>
